<template>
    <div>
        <h5 class="fw-bold mb-3">Zmiana hasła</h5>
        <p class="text-muted small mb-4">Upewnij się, że Twoje nowe hasło jest bezpieczne (minimum 8 znaków).</p>

        <form @submit.prevent="handleSave">
            <div class="row g-3 max-width-wrapper">
                <!-- AKTUALNE HASŁO -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Aktualne hasło</label>
                    <div class="input-group">
                        <input :type="showCurrentPassword ? 'text' : 'password'" class="form-control"
                            v-model="formData.passwordForm.currentPassword" autocomplete="current-password" :disabled="saving" />
                        <button class="btn btn-outline-secondary" type="button" :disabled="saving"
                            @click="showCurrentPassword = !showCurrentPassword">
                            <i class="bi" :class="showCurrentPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                    </div>
                </div>

                <!-- NOWE HASŁO z GENERATOREM -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Nowe hasło</label>
                    <div class="input-group">
                        <input :type="showPassword ? 'text' : 'password'" class="form-control"
                            v-model="formData.passwordForm.newPassword" autocomplete="new-password" :disabled="saving" />
                        <button class="btn btn-outline-secondary" type="button" :disabled="saving"
                            @click="showPassword = !showPassword">
                            <i class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                        <button class="btn btn-outline-secondary" type="button" title="Generuj losowe hasło"
                            :disabled="saving" @click="generatePassword">
                            <i class="bi bi-shuffle"></i>
                        </button>
                    </div>
                </div>

                <!-- POWTÓRZ NOWE HASŁO -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Powtórz nowe hasło</label>
                    <div class="input-group">
                        <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control"
                            v-model="formData.passwordForm.newPasswordConfirmation" autocomplete="new-password" :disabled="saving" />
                        <button class="btn btn-outline-secondary" type="button" :disabled="saving"
                            @click="showConfirmPassword = !showConfirmPassword">
                            <i class="bi" :class="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- PRZYCISK ZAPISU -->
            <div class="mt-4 max-width-wrapper">
                <button type="submit" class="btn btn-primary-dark d-flex align-items-center gap-2" :disabled="saving">
                    <i class="bi bi-floppy"></i>
                    <span>Zapisz zmiany</span>
                </button>
            </div>
        </form>

        <!-- LOADER -->
        <AppLoader :show="saving" :text="loaderText" />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import apiClient from '@/api'
import AppLoader from '@/components/AppLoader.vue'
import { webAlert } from '@/utils/dialog'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['update:modelValue'])

const formData = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const saving = ref(false)
const loaderText = ref('')

// Stany widoczności haseł
const showCurrentPassword = ref(false)
const showPassword = ref(false)
const showConfirmPassword = ref(false)

// Generator haseł
const generatePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()'
    let pass = ''
    for (let i = 0; i < 12; i++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length))
    }

    formData.value.passwordForm.newPassword = pass
    formData.value.passwordForm.newPasswordConfirmation = pass

    showPassword.value = true
    showConfirmPassword.value = true
}

// Obsługa zapisu i walidacja
const handleSave = async () => {
    const { currentPassword, newPassword, newPasswordConfirmation } = formData.value.passwordForm

    // 1. Sprawdzenie, czy wszystkie pola są wypełnione
    if (!currentPassword || !newPassword || !newPasswordConfirmation) {
        webAlert('Wszystkie pola formularza zmiany hasła są wymagane.')
        return
    }

    // 2. Sprawdzenie, czy nowe hasła są identyczne
    if (newPassword !== newPasswordConfirmation) {
        webAlert('Wprowadzone nowe hasła nie są identyczne.')
        return
    }

    // 3. Zapis via Axios
    saving.value = true
    loaderText.value = 'Zmiana hasła...'

    try {
        const response = await apiClient.post(
            {
                action: 'change-password',
                currentPassword,
                newPassword
            }
        )

        if (response.data?.status == 'success') {
            // Czyszczenie formularza po pomyślnej zmianie
            formData.value.passwordForm.currentPassword = ''
            formData.value.passwordForm.newPassword = ''
            formData.value.passwordForm.newPasswordConfirmation = ''
        }
        saving.value = false; 
        webAlert(response.data)

    } catch (error) {
        saving.value = false;
        webAlert(error.message)
    } finally {
        saving.value = false
    }
}
</script>

<style scoped>
.max-width-wrapper {
    max-width: 500px;
}
</style>